<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="parentx">
    <vs-sidebar
      class="v-nav-menu items-no-padding"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      v-hammer:swipe="onMenuSwipe"
    >
      <vs-popup
        class="country-selector-popup"
        style="color: #fff !important"
        background-color="rgba(0,0,0,.4)"
        :background-color-popup="colorx"
        title="Select country"
        :active.sync="countrySelectorActive"
      >
        <vs-row vs-justify="space-between" class="px-4" vs-align="center">
          <div
            @click.stop="setActiveCountry(c.id)"
            v-for="c in countries"
            :key="c.id"
            class="countryOption"
            :class="{ activeCountry: activeCountryId === c.id }"
            style="font-weight: bold"
          >
            <img
              :src="require(`@/assets/images/flags/${c.id}.png`)"
              style="object-fit: contain"
              width="45"
              height="45"
              class="block mx-auto mb-2"
            />{{ c.name }}
          </div>
        </vs-row>
      </vs-popup>
      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave" class="mt-4">
        <!-- <div class="flex justify-center mt-6 mb-6">
          <h1 class="text-white">{{ currentService.name }}</h1>
        </div> -->
        <!-- Header -->
        <div
          class="header-sidebar flex flex-col items-center justify-between pt-0"
          slot="header"
        >
          <!-- Venue select -->
          <div
            v-if="currentMenu.hasVenueSelect"
            :disabled="$store.state.themeProps.showFullSearchSlow"
            @click.stop="changeVenue"
            class="the-navbar__user-meta venue-picker mt-4"
          >
            <vs-row vs-justify="space-between" vs-align="center">
              <div style="display: flex; align-items: center">
                <div>
                  <img
                    key="onlineImg"
                    :src="
                      activeVenue.logoUrl
                        ? activeVenue.logoUrl
                        : require(`@/assets/images/venue-image-inverted.png`)
                    "
                    alt="venue-img"
                    style="object-fit: contain"
                    width="25"
                    height="25"
                    class="cursor-pointer block"
                  />
                </div>
                <!-- var 8 px -->
                <div
                  class="leading-tight hidden sm:block cursor-pointer"
                  style="margin-left: 10px; text-align: left"
                  v-if="isMouseEnter || !reduce"
                >
                  <p style="line-height: 1">{{ trimName(activeVenue.name) }}</p>
                </div>
              </div>
              <template>
                <feather-icon
                  icon="ChevronDownIcon"
                  style="color: rgba(var(--vs-dark), 1) !important"
                  class="m-0 cursor-pointer"
                />
              </template>
            </vs-row>
          </div>

          <!-- Country selector -->

          <div
            v-if="currentMenu.hasCountrySelect"
            @click.stop="changeCountry"
            class="the-navbar__user-meta venue-picker mt-4"
          >
            <vs-row vs-justify="space-between" vs-align="center">
              <div style="display: flex; align-items: center">
                <div>
                  <img
                    key="onlineImg"
                    :src="
                      require(`@/assets/images/flags/${activeCountry.id}.png`)
                    "
                    alt="venue-img"
                    style="object-fit: contain"
                    width="25"
                    height="25"
                    class="cursor-pointer block"
                  />
                </div>
                <!-- var 8 px -->
                <div
                  class="leading-tight hidden sm:block cursor-pointer"
                  style="margin-left: 10px; text-align: left"
                  v-if="isMouseEnter || !reduce"
                >
                  <p style="line-height: 1">{{ activeCountry.name }}</p>
                </div>
              </div>
              <template>
                <feather-icon
                  icon="ChevronDownIcon"
                  style="color: rgba(var(--vs-dark), 1) !important"
                  class="m-0 cursor-pointer"
                />
              </template>
            </vs-row>
          </div>

          <!-- <div v-else class="flex justify-center mb-1">
            <img src="@/assets/images/rekom_logo_long.svg" style="width: 90%; vertical-align: middle" />
          </div> -->

          <!-- /Logo -->

          <!-- Menu Buttons -->
          <!--           <div>
            <template>
              <feather-icon
                svgClasses="h-8 w-8"
                color="beige"
                id="btnVNavMenuMinToggler"
                class="mr-0 cursor-pointer"
                icon="MenuIcon"
                @click.stop="showSidebar"
              />
            </template>
          </div> -->
          <!-- /Menu Toggle Buttons -->
        </div>
        <!-- /Header -->
        <!--        <vs-divider
          color="primary"
          style="margin-top: 0"
          v-if="this.$store.state.themeProps.theme === 'semi-dark'"
        />
        <vs-divider v-else /> -->
        <!-- Header Shadow -->
        <!-- <div class="shadow-bottom" v-show="showShadowBottom" /> -->

        <!-- Menu Items -->
        <component
          :is="scrollbarTag"
          ref="verticalNavMenuPs"
          class="scroll-area-v-nav-menu"
          :settings="settings"
          @ps-scroll-y="psSectionScroll"
          @scroll="psSectionScroll"
          :key="$vs.rtl"
        >
          <template v-for="(item, index) in menuItemsUpdated">
            <!-- Group Header -->
            <span
              v-if="item.header && !verticalNavMenuItemsMin"
              class="navigation-header truncate"
              :key="`header-${index}`"
            >
              {{ item.header }}
            </span>
            <!-- /Group Header -->

            <template v-else-if="!item.header">
              <!-- Nav-Item -->
              <v-nav-menu-item
                v-if="!item.submenu"
                :key="`item-${index}`"
                :index="index"
                :to="item.slug !== 'external' ? item.url : null"
                :href="item.slug === 'external' ? item.url : null"
                :icon="item.icon"
                :target="item.target"
                :isDisabled="item.disabled"
                :slug="item.slug"
              >
                <span v-show="!verticalNavMenuItemsMin" class="truncate">{{
                  item.name
                }}</span>
                <vs-chip
                  class="ml-auto"
                  :color="item.tagColor"
                  v-if="item.tag && (isMouseEnter || !reduce)"
                  >{{ item.tag }}</vs-chip
                >
              </v-nav-menu-item>

              <!-- Nav-Group -->
              <template v-else>
                <v-nav-menu-group
                  :key="`group-${index}`"
                  :openHover="openGroupHover"
                  :group="item"
                  :groupIndex="index"
                  :open="isGroupActive(item)"
                />
              </template>
              <!-- /Nav-Group -->
            </template>
          </template>
          <div class="my-8"></div>
          <!-- Spacer -->
        </component>
        <!-- /Menu Items -->
      </div>
      <!--<vs-divider />-->
      <profile-drop-down />
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div
      v-if="!isVerticalNavMenuActive"
      class="v-nav-menu-swipe-area"
      v-hammer:swipe="onSwipeAreaSwipe"
    />
    <!-- /Swipe Gesture -->
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VNavMenuGroup from "./VerticalNavMenuGroup.vue";
import VNavMenuItem from "./VerticalNavMenuItem.vue";
import ProfileDropDown from "./ProfileDropDown.vue";

import Logo from "../Logo.vue";
import { mapGetters } from "vuex";
export default {
  name: "v-nav-menu",
  components: {
    ProfileDropDown,
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    Logo,
  },
  props: {
    logo: { type: String },
    openGroupHover: { type: Boolean, default: false },
    parent: { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems: { type: Array, required: true },
    title: { type: String },
  },
  data: () => ({
    colorx: "#153130",
    countrySelectorActive: false,
    clickNotClose: false, // disable close navMenu on outside click
    isMouseEnter: false,
    reduce: false, // determines if navMenu is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    settings: {
      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true,
    },
    showShadowBottom: false,
  }),
  computed: {
    isVerticalNavMenuActive() {
      return this.$store.state.themeProps.isVerticalNavMenuActive;
    },
    currentMenu() {
      const curentMenuIdx = this.$store.getters["services/currentServiceIdx"];
      return this.$store.getters["services/services"][curentMenuIdx];
    },

    activeUserInfo() {
      return this.$store.state.themeProps.AppActiveUser;
    },
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userVenues: "venues/venues",
      currentService: "services/currentService",
      countries: "venues/countries",
      activeCountryId: "venues/activeCountryId",
      activeCountry: "venues/activeCountry",
    }),
    isGroupActive() {
      return (item) => {
        const path = this.$route.fullPath;
        const routeParent = this.$route.meta
          ? this.$route.meta.parent
          : undefined;
        let open = false;

        let func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              if (
                item.url &&
                (path === item.url || routeParent === item.slug)
              ) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };
        func(item);
        return open;
      };
    },
    menuItemsUpdated() {
      let clone = this.navMenuItems.slice();

      for (let [index, item] of this.navMenuItems.entries()) {
        if (item.header && item.items.length && (index || 1)) {
          let i = clone.findIndex((ix) => ix.header === item.header);
          for (let [subIndex, subItem] of item.items.entries()) {
            clone.splice(i + 1 + subIndex, 0, subItem);
          }
        }
      }

      return clone;
    },
    // isVerticalNavMenuActive: {
    //   get() {
    //     return this.$store.state.themeProps.isVerticalNavMenuActive;
    //   },
    //   set(val) {
    //     this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", val);
    //   },
    // },
    layoutType() {
      return this.$store.state.themeProps.mainLayoutType;
    },
    reduceButton: {
      get() {
        return this.$store.state.themeProps.reduceButton;
      },
      set(val) {
        this.$store.commit("TOGGLE_REDUCE_BUTTON", val);
      },
    },
    isVerticalNavMenuReduced() {
      return Boolean(this.reduce && this.reduceButton);
    },
    verticalNavMenuItemsMin() {
      return this.$store.state.themeProps.verticalNavMenuItemsMin;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.themeProps.windowWidth;
    },
  },
  watch: {
    $route() {
      if (this.isVerticalNavMenuActive && this.showCloseButton)
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
    },
    reduce(val) {
      const verticalNavMenuWidth = val
        ? "reduced"
        : this.$store.state.themeProps.windowWidth < 1200
        ? "no-nav-menu"
        : "default";

      this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);

      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
    layoutType() {
      this.setVerticalNavMenuWidth();
    },
    reduceButton() {
      this.setVerticalNavMenuWidth();
    },
    windowWidth() {
      this.setVerticalNavMenuWidth();
    },
  },
  methods: {
    setActiveCountry(countryId) {
      if (countryId !== this.activeCountryId) {
        this.$store.commit("venues/setActiveCountry", countryId);
        this.switchCountry(countryId);
        this.countrySelectorActive = false;
        this.$vs.notify({
          title: "Country changed",
          text: "Country switched to " + this.activeCountry.name,
        });
      }
    },
    changeCountry() {
      this.countrySelectorActive = !this.countrySelectorActive;
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
    async changeVenue() {
      //console.log("i change venue");
      // Send true hvis show = false HVIS searchBar ikke lige har sendt en request
      if (!this.$store.state.themeProps.showFullSearchSlow) {
        this.$store.commit("setShowFullSearch", true);
      }
    },
    async onSelect(venueId) {
      if (typeof venueId === "string") {
        console.log("Setting active venue to", venueId);
        this.switchVenue(venueId);
      }
    },
    logout() {
      this.$router.push("/auth/login").catch(() => {});
    },
    toggleSidebar() {
      this.isSidebarActive = !this.isSidebarActive;
    },
    trimName(str) {
      return str.length > 16 ? str.substring(0, 16).trim() + "..." : str;
    },
    async switchVenue(venue) {
      console.log("Setting active venue for", venue.venueId);

      this.switchVenue(venue.venueId);
      this.activeVenue = this.$store.getters["venues/activeVenue"];
    },
    onMenuSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && this.$vs.rtl) {
        if (this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = false;
      }
      // Swipe Left
      else if (event.direction === 2 && !this.$vs.rtl) {
        if (this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = false;
      }
    },
    onSwipeAreaSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && !this.$vs.rtl) {
        if (!this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = true;
      }
      // Swipe Left
      else if (event.direction === 2 && this.$vs.rtl) {
        if (!this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = true;
      }
    },
    psSectionScroll() {
      const scroll_el =
        this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs;
      this.showShadowBottom = scroll_el.scrollTop > 0 ? true : false;
    },
    mouseEnter() {
      if (this.reduce)
        this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);
      this.isMouseEnter = true;
    },
    mouseLeave() {
      if (this.reduce)
        this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", true);
      this.isMouseEnter = false;
    },
    setVerticalNavMenuWidth() {
      if (this.windowWidth > 1200) {
        if (this.layoutType === "vertical") {
          // Set reduce
          this.reduce = this.reduceButton ? true : false;

          // Open NavMenu
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin =
            this.reduceButton && !this.isMouseEnter ? true : false;
          this.$store.commit(
            "UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN",
            verticalNavMenuItemsMin
          );

          // Menu Action buttons
          this.clickNotClose = true;
          this.showCloseButton = false;

          const verticalNavMenuWidth = this.isVerticalNavMenuReduced
            ? "reduced"
            : "default";
          this.$store.dispatch(
            "updateVerticalNavMenuWidth",
            verticalNavMenuWidth
          );

          return;
        }
      }

      // Close NavMenu
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);

      // Reduce button
      if (this.reduceButton) this.reduce = false;

      // Menu Action buttons
      this.showCloseButton = true;
      this.clickNotClose = false;

      // Update NavMenu Width
      this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");

      // Remove Only Icon in Menu
      this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);

      // if(this.layoutType === 'vertical' || (this.layoutType === 'horizontal' && this.windowWidth < 1200))
      // if (this.windowWidth < 1200) {

      //   // Close NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      //   // Reduce button
      //   if (this.reduceButton) this.reduce = false

      //   // Menu Action buttons
      //   this.showCloseButton = true
      //   this.clickNotClose   = false

      //   // Update NavMenu Width
      //   this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      //   // Remove Only Icon in Menu
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // } else {

      //   // Set reduce
      //   this.reduce = this.reduceButton ? true : false

      //   // Open NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

      //   // Set Menu Items Only Icon Mode
      //   const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

      //   // Menu Action buttons
      //   this.clickNotClose   = true
      //   this.showCloseButton = false

      //   const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
      //   this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      // }
    },
    toggleReduce(val) {
      this.reduceButton = val;
      this.setVerticalNavMenuWidth();
    },
  },
  mounted() {
    this.setVerticalNavMenuWidth();
  },
};
</script>
<style lang="scss" scoped>
.activeCountry {
  opacity: 0.5;
}
.countryOption:not(.activeCountry) {
  cursor: pointer;
}
.countryOption:hover {
  opacity: 0.5;
}
</style>
<style lang="scss" >
.country-selector-popup > div.vs-popup > header > div > h3 {
  color: #fff !important;
}

.country-selector-popup > div.vs-popup > header > i {
  color: #fff !important;
}

.vs-sidebar-primary:not(.vs-sidebar-position-right) {
  left: 76px !important;
}

.vs-sidebar-animate-leave-to:not(.vs-sidebar-position-right) .vs-sidebar {
  /*  transform: none; */
  /*opacity: 0;
  width: 0px !important; */
  /*  width: 0px; */
}

@import "@/assets/scss/vuexy/components/verticalNavMenu.scss";

@font-face {
  font-family: "HelNeue";
  src: url("./fonts/Helvetica-Neue-Condensed-Bold.woff") format("woff"),
    /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
      url("./fonts/Helvetica-Neue-Condensed-Bold.ttf") format("truetype"); /* Chrome 4+, Firefox 3.5, Opera 10+, Safari 3—5 */
}

.rekom-font {
  text-decoration: none;
  text-transform: uppercase;
  font-family: HelNeue;
  font-size: 20px;
  color: #404040;
  border-bottom: 3px solid #3ca4c3;
}

.venue-picker {
  border-radius: 0.5rem;
  padding: 10px;
  width: 100%;
  /* margin-right: 10px; */
  color: rgba(var(--vs-dark), 1);
  font-weight: 600;
  text-align: middle;
  background-color: rgba(var(--vs-success), 1);
  /*  background-image: linear-gradient(-60deg, #65bca0 0%, #439cb0 100%); */
  cursor: pointer;
  transition: opacity 0.2s;
}

.venue-picker:hover {
  opacity: 0.8;
}

#btnVNavMenuMinToggler {
  vertical-align: middle;
}
</style>
